import { render, staticRenderFns } from "./resMain.vue?vue&type=template&id=66747817&scoped=true"
import script from "./resMain.vue?vue&type=script&lang=js"
export * from "./resMain.vue?vue&type=script&lang=js"
import style0 from "./resMain.vue?vue&type=style&index=0&id=66747817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66747817",
  null
  
)

export default component.exports